import {LiveAnnouncer} from '@angular/cdk/a11y';
import {inject, Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy} from '@angular/router';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PageTitleStrategy extends TitleStrategy {
  private readonly documentTitle = inject(Title);
  private readonly liveAnnouncer = inject(LiveAnnouncer);
  private titleContext: string | undefined;

  private readonly appName: string = environment.appName
    .replace(/-/g, ' ')
    .replace('lu', 'LU')
    .replace(/\b\w/g, (char) => char.toUpperCase());

  override buildTitle(snapshot: RouterStateSnapshot): string {
    const titleSegments: string[] = [];
    let route: ActivatedRouteSnapshot | null = snapshot.root;

    while (route) {
      const titleSegment: string | undefined = this.getResolvedTitleForRoute(route);
      const previousTitleSegment: string | undefined = titleSegments[titleSegments.length - 1];

      if (titleSegment && titleSegment !== previousTitleSegment) {
        titleSegments.push(titleSegment);
      }

      route = route.firstChild;
    }

    if (this.titleContext) {
      titleSegments.splice(1, 0, this.titleContext);
    }

    return [this.appName, ...titleSegments].join(' | ');
  }

  setTitleContext(titleContext: string | undefined): boolean {
    const hasChanged = this.titleContext !== titleContext;
    this.titleContext = titleContext;
    return hasChanged;
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle: string = this.buildTitle(snapshot);

    this.documentTitle.setTitle(pageTitle);
    void this.liveAnnouncer.announce(pageTitle, 'polite');
  }
}
